import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { GetStoreInterface } from '@app/shared/services/common/getStoreList.interface';
import { DashboardService } from '@app/shared/services/dashboard/dashboard.service';
import { CommonService } from '@app/shared/services/common/common.service';
import { ReportService } from '@app/shared/services/reports/report.service';
// import { Observable } from 'rxjs';


@Component({
  selector: 'app-dashboard-count-sub-component',
  templateUrl: './dashboard-count-sub-component.component.html',
  styleUrls: ['./dashboard-count-sub-component.component.css']
})
export class DashboardCountSubComponentComponent implements OnInit, OnChanges {
  @Input() title: string;
  @Input() storeList: GetStoreInterface[];
  @Input() getDailyVisitors = 0;
  @Input() getDesignViewedCount = 0;
  @Input() getOpenCartsQuery = 0;
  @Input() getStoreAdminEarningReportAp = 0;
  @Input() GetTotalEndUsersOfStore = 0;
  @Input() TotalNoOfPublishedProducts = 0;
  @Input() TotalNoOfStores = 0;
  @Input() StoreUrl = null;
  countTo = 0;
  form: FormGroup;
  @Input() mapData = (res: any) => res.Data.ResponseData;

  constructor(private formBuilder: FormBuilder,
    public dashboardService: DashboardService,
    public commonService: CommonService,
    public reportService: ReportService) {

    this.form = this.formBuilder.group({
      StoreId: new FormControl('')
    });
  }

  ngOnInit() {
  }
  ngOnChanges(changes: any): void {

    if (this.storeList.length > 0) {

      this.form.patchValue({
        StoreId: this.storeList[0].StoreId
      });
      this.onChange(this.storeList[0].StoreId);
    }
  }

  async onChange(storeId: number) {
    this.StoreUrl = this.storeList.find(x => x.StoreId == storeId).StoreUrl;
    this.getDailyVisitors = 0;
    this.getDesignViewedCount = 0;
    this.getOpenCartsQuery = 0;
    this.getStoreAdminEarningReportAp = 0;
    this.GetTotalEndUsersOfStore = 0;
    this.form.patchValue({
      StoreId: storeId
    });
    this.commonService.getDailyVisitors(storeId).subscribe(
      (res: any) => {
        if (res.StatusCode === 200) {
          this.getDailyVisitors = this.mapData(res);
        } else if (res.StatusCode === 500) {
        }
      }
    );
    this.commonService.getDesignViewedCount(storeId).subscribe(
      (res: any) => {
        if (res.StatusCode === 200) {
          var value = this.mapData(res);
          this.getDesignViewedCount = value == null ? 0 : value;
        } else if (res.StatusCode === 500) {
        }
      }
    );
    this.commonService.getOpenCartsQuery(storeId).subscribe(
      (res: any) => {
        if (res.StatusCode === 200) {
          this.getOpenCartsQuery = this.mapData(res);
        } else if (res.StatusCode === 500) {
        }
      }
    );
    this.reportService.getStoreAdminEarningReportAp(storeId).subscribe(
      (res: any) => {
        if (res.StatusCode === 200) {
          this.getStoreAdminEarningReportAp = this.mapData(res);
        } else if (res.StatusCode === 500) {
        }
      }
    );
    this.dashboardService.GetTotalEndUsersOfStore(storeId).subscribe(
      (res: any) => {
        if (res.StatusCode === 200) {
          this.GetTotalEndUsersOfStore = this.mapData(res);
        } else if (res.StatusCode === 500) {
        }
      }
    );
  }
  isNumber(e) {return typeof e === 'number'}
}






//import { Component, Input, OnChanges, OnInit } from '@angular/core';
//import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
//import { GetStoreInterface } from '@app/shared/services/common/getStoreList.interface';
//import { DashboardService } from '@app/shared/services/dashboard/dashboard.service';
//import { CommonService } from '@app/shared/services/common/common.service';
//import { ReportService } from '@app/shared/services/reports/report.service';
//import { Observable } from 'rxjs';

//@Component({
//  selector: 'app-dashboard-count-sub-component',
//  templateUrl: './dashboard-count-sub-component.component.html',
//  styleUrls: ['./dashboard-count-sub-component.component.css']
//})
//export class DashboardCountSubComponentComponent implements OnInit, OnChanges {
//  @Input() service: 'GetTotalEndUsersOfStore' | 'getStoreAdminEarningReportAp' | 'getDailyVisitors' | 'getDesignViewedCount' | 'getOpenCartsQuery' | 'none';
//  @Input() title: string;
//  @Input() color: 'earn-store' | 'ttl-store' | 'ttl-od dash-btm-gd dash-lt-blue' | 'ttl-od dash-btm-gd dash-blue' | 'ttl-od dash-btm-gd dash-green' | 'ttl-mn' | 'ttl-od';
//  @Input() storeList: GetStoreInterface[];
//  @Input() icon: string;
//  @Input() labelClass = 'label-brwn';
//  @Input() topDesign = true;
//  @Input() currency = false;
//  @Input() count = 0;
//  @Input() static = false;
//  countTo = 0;
//  form: FormGroup;
//  @Input() mapData = (res: any) => res.Data.ResponseData;

//  constructor(private formBuilder: FormBuilder,
//    public dashboardService: DashboardService,
//    public commonService: CommonService,
//    public reportService: ReportService) {

//    this.form = this.formBuilder.group({
//      StoreId: new FormControl('')
//    });
//  }

//  ngOnInit() {
//  }
//  ngOnChanges(changes: any): void {

//    if (this.storeList.length > 0 && !this.static) {

//      this.form.patchValue({
//        StoreId: this.storeList[0].StoreId
//      });
//      this.onChange(this.storeList[0].StoreId);
//    }
//  }

//  async onChange(storeId: number) {
//    this.count = 0;
//    this.form.patchValue({
//      StoreId: storeId
//    });
//    let service: Observable<any> = null;
//    switch (this.service) {
//      case 'getDailyVisitors':
//        service = this.commonService.getDailyVisitors(storeId);
//        break;
//      case 'getDesignViewedCount':
//        service = this.commonService.getDesignViewedCount(storeId);
//        break;
//      case 'getOpenCartsQuery':
//        service = this.commonService.getOpenCartsQuery(storeId);
//        break;
//      case 'getStoreAdminEarningReportAp':
//        service = this.reportService.getStoreAdminEarningReportAp(storeId);
//        break;
//      case 'GetTotalEndUsersOfStore':
//        service = this.dashboardService.GetTotalEndUsersOfStore(storeId);

//    }
//    if (service) {

//      service.subscribe(
//        (res: any) => {
//          if (res.StatusCode === 200) {
//            this.count = this.mapData(res);
//          } else if (res.StatusCode === 500) {
//          }
//        }
//      );
//    }
//  }
//}



